import { Component, Inject, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlBase } from '../../base/control-base/control-base.component';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CoreService_TOKEN } from '../../../tokens/injection-tokens';
import { ICoreService } from '../../../interfaces/core-service.interface';

@Component({
    selector: 'domain-for-sale-list-control',
    templateUrl: 'domain-for-sale-list.control.html',
    standalone: false,
})
export class DomainForSaleListTab extends ControlBase implements OnInit {
    public domainForSaleList: string[] = [];

    constructor(
        @Inject(CoreService_TOKEN)
        private coreService: ICoreService,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService);
    }

    public ngOnInit(): void {
        this.getDomainForSaleList();
    }

    public getDomainForSaleList = async (): Promise<any> => {
        return firstValueFrom(this.coreService.getDomainForSaleList())
            .then(res => {
                this.domainForSaleList = res.result;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
            });
    };
}
